import axios from './axiosInstance'
import {Event} from "../types/eventTypes"
import {Competition} from "../types/competitionTypes";

const baseUrl = process.env.REACT_APP_BASE_URL+"/match";

interface startResponse {
    competitions: Competition[];
    matchDays: number[];
    additionalInfo: {[key: number] : {start: string, end: string, type: string}};
    matchDayEvents: any;
    mostRecentMatchDayIndex: number;
}

export async function getStartingData(competition? : string, abortController?: AbortController | null): Promise<startResponse> {
    if (competition) {
        const params = {competition}
        const res = await axios.get(baseUrl + "/competitionEventDays", {params, signal: abortController ? abortController.signal : undefined});
        return res.data;
    } else {
        const res = await axios.get(baseUrl + "/competitionEventDays", {signal: abortController ? abortController.signal : undefined});
        return res.data;
    }


}

export async function getMatchDayEvents(competition: string, matchDay: number): Promise<Event[]> {
    const params = {competition, matchDay};
    const res = await axios.get(baseUrl + "/matchDayEvents", {params} );
    return res.data;
}

export async function getCompleteDatasourceInfo(eventId: string): Promise<any> {
    const params = {eventId};
    const res = await axios.get(baseUrl + `/${eventId}/completeDatasourcesInfo`, {params} );
    return res.data;
}